export default __webpack_public_path__ + "static/media/blue_marker_linear_spritesheet.62f4368a.png";